/**
 * setAttributes accepts an element and attributes and returns each element
 * with the attributes added to it
 * @param {HTMLInputElement | HTMLFormElement} element - the element that needs attributes
 * @param {AnyObject} attributes - the attributes to be assigned to the element
 *
 */
export const setAttributes = (element, attributes) => Object.keys(attributes).forEach(key => element.setAttribute(key, attributes[key]));
/**
 * formPost accepts a path, params, and a method to create a POST-able form
 * @param {string} path - the path where the form will POST to
 * @param {AnyObject} params - the form field inputs/information that needs to be POSTed
 * @param {'post'} method - the method by which the form will be submitted, default is 'post'
 */
const formPost = (path, params, method = 'post', target = '_blank') => {
    const form = document.createElement('form');
    setAttributes(form, { method, action: path, target });
    Object.keys(params).forEach(key => {
        const hiddenField = document.createElement('input');
        setAttributes(hiddenField, {
            type: 'hidden',
            name: key,
            value: params[key]
        });
        form.appendChild(hiddenField);
    });
    if (document.body) {
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }
};
export default formPost;
